module.exports = __webpack_public_path__ + "files/194b2e6c0aa3fa7fbb148ff769ed9dc9.png";